import PropTypes from "prop-types"
import { Card, CardBody, Table } from "reactstrap"

const RankedProductsCard = ({ title, description, items, isLoading, hasError }) => (
  <Card className="shadow-sm border-0 h-100">
    <CardBody className="p-4">
      <div className="mb-3">
        <h5 className="mb-1">{title}</h5>
        <p className="mb-0 text-muted">{description}</p>
      </div>

      <div className="table-responsive">
        <Table className="mb-0 align-middle table-hover-effect table-interactive" hover>
          <thead className="table-light">
            <tr>
              <th className="text-nowrap" style={{ width: 55 }}>
                #
              </th>
              <th className="text-nowrap">Producto</th>
              <th className="text-nowrap text-end">Total</th>
              <th className="text-nowrap text-end">Unidades</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td className="text-center text-muted py-4" colSpan="4">
                  Cargando productos...
                </td>
              </tr>
            ) : hasError ? (
              <tr>
                <td className="text-center text-muted py-4" colSpan="4">
                  No se pudo cargar la información.
                </td>
              </tr>
            ) : items.length ? (
              items.map((product, index) => (
                <tr key={product.name}>
                  <td className="fw-semibold text-nowrap text-muted">{index + 1}</td>
                  <td className="fw-semibold" title={product.fullName || product.name}>
                    {product.name}
                  </td>
                  <td className="text-nowrap text-end fw-semibold">{product.amount}</td>
                  <td className="text-nowrap text-end text-muted">{product.units}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="text-center text-muted py-4" colSpan="4">
                  No hay ventas para mostrar.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </CardBody>
  </Card>
)

RankedProductsCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      fullName: PropTypes.string,
      amount: PropTypes.string.isRequired,
      units: PropTypes.string.isRequired,
    })
  ).isRequired,
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool,
}

RankedProductsCard.defaultProps = {
  isLoading: false,
  hasError: false,
}

export default RankedProductsCard